import { defineMessages } from 'react-intl';

export const messages: {
	expandSection: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapseSection: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	expandSection: {
		id: 'jsm-solution-composer-plan.task-card.card-header.expand-section',
		defaultMessage: 'Expand section',
		description: 'Accessible label for the expand button in the task card header',
	},
	collapseSection: {
		id: 'jsm-solution-composer-plan.task-card.card-header.collapse-section',
		defaultMessage: 'Collapse section',
		description: 'Accessible label for the collapse button in the task card header',
	},
});
